import { router } from '@/app/router.js';

/** The message the push worker sends an open window of the app when a notification is clicked. */
export const OPEN_CHAT_MESSAGE = 'ct:open-chat';

/** Whether the URL is a path inside this app: one leading slash, never `//host`. */
function isAppPath(url: unknown): url is string {
  return (
    typeof url === 'string' && url.startsWith('/') && !url.startsWith('//')
  );
}

/**
 * Opens the chat a clicked reply notification points at (MEDA-1208). The push worker does not
 * control the app's pages, so it cannot navigate them; it focuses the window and sends this message
 * instead, and the answer on the message's port tells it the page took it. Returns the unsubscribe.
 */
export function followPushClicks(
  navigate: (href: string) => void = (href) => void router.navigate({ href }),
  container: EventTarget = navigator.serviceWorker,
): () => void {
  const onMessage = (event: Event) => {
    const { data, ports } = event as MessageEvent<{
      type?: unknown;
      url?: unknown;
    } | null>;
    if (data?.type !== OPEN_CHAT_MESSAGE || !isAppPath(data.url)) return;
    navigate(data.url);
    ports?.[0]?.postMessage('opened');
  };
  container.addEventListener('message', onMessage);
  return () => container.removeEventListener('message', onMessage);
}
